import { getAllowedScheduleEvent, insertSchedule, getRestCourseCountOfNextWeek } from '@/api/releaseTime'
import { getNextDate } from '@/utils/date.js'
const release = {
  namespaced: true,

  state: {
    viewRange: {
      start: new Date(),
      end: new Date()
    },
    events: [],
    selects: [],
    currentView: 1, // [day, week]
    currentDate: new Date(),
    loading: false,
    hadInited: false,
    canSubmit: true,
    isSend: false,
    errorText: 'errorText',
    initEvents: [],
    eventIds:[],
    modifyNextWeekNumber: 0,
    modifyNextWeekNumbers: 0,
    setSelfSchedulesEnableThisTimes: false
  },
  mutations: {
    SET_EVENT_IDS: (state, id) => {
      state.eventIds.push(id)
    },
    SET_VIEW_RANGE: (state, viewRange) => {
      state.viewRange = viewRange
    },
    SET_LOADING: (state, loading) => {
      state.loading = loading
    },
    SETCANSUBMIT: (state, canSubmit) => {
      state.canSubmit = canSubmit
    },
    SETISSEND: (state, isSend) => {
      state.isSend = isSend
    },
    SETERRORTEXT: (state, errorText) => {
      state.errorText = errorText
    },
    MODIFYNEXTWEEKNUMBER:(state, num) => {
      state.modifyNextWeekNumber = num
      state.modifyNextWeekNumbers = num
    },
    SETSELFSCHEDULESENABLETHISTIME: (state, flag) => {
      state.setSelfSchedulesEnableThisTimes = flag
    },
    SET_CURRENT_VIEW: (state, view) => {
      state.currentView = view
    },
    SET_CURRENT_DATE: (state, date) => {
      state.currentDate = date
      console.log('date====', state.currentDate)
    },
    SET_EVENTS: (state, events) => {
      state.events = events
      state.initEvents = Object.assign([],events)
    },
    UPDATE_BUSY_EVENTS:　(state, flag) => {

      let nextMonday = getNextDate(-7)
      let nextSunday = getNextDate(-13)
      let beginDate = new Date(nextMonday+'T00:00:00')
      let endDate = new Date(nextSunday+'T24:00:00')

      let a = state.initEvents.filter(i =>{
        return i.BusyTimeCheck && i.BusyTimeCheckFlag==flag && i.Status !== 'Confirmed' && i.Disabled !== true && i.Type !== 'BusyTime'
      }).filter(item=>{
        let start = new Date(item.StartTime)
        return start >= beginDate && start <= endDate
      })
      if(a.length > state.modifyNextWeekNumber){
        state.errorText = 'No modification for plotted schedule'
        return
      }

      let arr = state.initEvents
      //.filter(t=>t.BusyTimeCheckFlag==flag && t.BusyTimeCheck)
      .map(i => {
        if (i.BusyTimeCheck && i.BusyTimeCheckFlag==flag && i.Status !== 'Confirmed' && i.Disabled !== true) {
            i.Status = 'Waited'
        }
        return i
      })
      state.events = arr
      state.canSubmit = true
    },
    UPDATE_BUSY_EVENTS_CANCLE: (state, flag) => {
      let arr = state.initEvents.map(i => {
        if (i.BusyTimeCheckFlag==flag && i.Status !== 'Confirmed') {
            i.Status = 'Canceled'
        }
        return i
      })
      state.events = arr
      state.canSubmit = true
    },
    UPDATE_EVENTS: (state, array) => {
      console.log(state.modifyNextWeekNumber);
      
      let arr = state.events.map(i => { //设置单个日期状态
        if (i.StartTime === array.StartTime) {
          if (i.Status === 'Waited') {
            i.Status = 'Canceled'
          } else if (i.Status === 'Canceled') {
            i.Status = 'Waited'
          }
          array.Status=i.Status
        }
        return i
      })
      //设置busytime的全选状态
    //   let busyTime = Object.assign([],arr).filter(item => {
    //     return item.StartTime.substring(0,10) === array.StartTime.substring(0,10)
    //   }).filter(item => {
    //     return item.BusyTimeCheck
    //   }).every(item => {
    //     return item.Status === 'Waited' || item.Status === 'Confirmed'
    //   })

    if(array.BusyTimeCheck){
        if(array.Status=='Canceled'){
            var check=arr.find(t=>t.BusyTimeCheckFlag==array.BusyTimeCheckFlag && t.Type=="BusyTime" && t.Status=='Waited')
            if(check){
                for(var i=0;i<arr.length;i++){
                    if(arr[i].BusyTimeCheckFlag==check.BusyTimeCheckFlag && arr[i].Type=="BusyTime" ){
                        arr[i].Status='Canceled'
                    }
                }
            }
        }else if(array.Status=='Waited'){
            var check=arr.filter(t=>t.BusyTimeCheckFlag==array.BusyTimeCheckFlag && t.BusyTimeCheck && t.Type!="BusyTime")
                    .every(t=>t.Status=='Waited' || t.Status=='Confirmed')
            if(check){
                for(var i=0;i<arr.length;i++){
                    if(arr[i].BusyTimeCheckFlag==array.BusyTimeCheckFlag && arr[i].Type=="BusyTime" ){
                        arr[i].Status='Waited'
                    }
                }
            }
        }
    }
    //  var busyTime = arr.filter(t=>t.BusyTimeCheck && t.BusyTimeCheckFlag==array.BusyTimeCheckFlag)
    //     .every(t=>{
    //         return t.Status === 'Waited' || t.Status === 'Confirmed'
    //     }) 
    //   let type  = busyTime ? 'checked' :'noChecked'
    //   if(type){
    //     let curCheck = new Date(array.StartTime).dateClone();
    //     let btnData = new Date(curCheck.setDate(curCheck.getDate() + 1)) //busytime按钮的startTime为第二天的0点 故天数+1
    //     let s = arr.map(i => {
    //       if(i.StartTime == formatDate(btnData, 'yyyy-MM-dd')+'T00:00:00' && i.Status != 'Confirmed'){
    //         if(type === 'checked'){
    //           i.Status = 'Waited'
    //         }else{
    //           i.Status = 'Canceled'
    //         }
    //       }
    //       return i

    //     })
    //     state.events = s
    //   }
      state.events=arr
      state.canSubmit = true
    },
    UPDATE_SELECTS: (state, flag) => {
      let arr = state.events.filter(item => 
        item.Status === 'Waited' && item.Type!='BusyTime'
      )
      let nextMonday = getNextDate(-7)
      let nextSunday = getNextDate(-13)
        
      let beginDate = new Date(nextMonday+'T00:00:00')
      let endDate = new Date(nextSunday+'T24:00:00')
    
      let nextWeekArr = arr.filter(item=>{
        let start = new Date(item.StartTime)
        return start >= beginDate && start <= endDate
      })
      // let arrs = arr.map(i => {
      //   return {
      //     end: i.EndTime,
      //     start: i.StartTime
      //   }
      // })
      state.selects = arr
      let a = state.modifyNextWeekNumbers
      state.modifyNextWeekNumber = a - nextWeekArr.length
    },
    UPDATE_ALLNOSELECTS: (state, flag) => { //设置全不选
      state.selects = []
    },
    UPDATE_CANSUBMIT: (state, value) => {},
    SET_HAD_INITED: (state, value) => {
      state.hadInited = value
    }
  },
  actions: {
    setEventIds({commit},value){
        commit("SET_EVENT_IDS",value)
    },
    setCanSubmit ({ commit }, value) {
      commit('SETCANSUBMIT', value)
    },
    setIsSend ({ commit }, value) {
      commit('SETISSEND', value)
    },
    setErrorText ({ commit }, value) {
      commit('SETERRORTEXT', value)
    },
    setCurrentView ({ commit }, view) {
      commit('SET_CURRENT_VIEW', view)
    },

    upEvents ({ commit }, array) {
        window.eventIds=[]
        window._0eventIds=[]
      commit('UPDATE_EVENTS', array)
      commit('UPDATE_SELECTS', array)
    },
    upBusyTime({ commit }, flag) {
        window.eventIds=[]
        window._0eventIds=[]
      commit('UPDATE_BUSY_EVENTS', flag)
      commit('UPDATE_SELECTS', flag)
    },
    upBusyTimeCancle({ commit }, flag) {
        window.eventIds=[]
        window._0eventIds=[]
      commit('UPDATE_BUSY_EVENTS_CANCLE', flag)
      commit('UPDATE_SELECTS', flag)
    },
    upCanSubmit ({ commit }, value) {
      commit('UPDATE_CANSUBMIT', value)
    },
    setCurrentDate ({ commit }, date) {
      commit('SET_CURRENT_DATE', date)
    },
    // 这个action在每次切换日期的时候都会被调用, 判断缓存的数据范围是否改变并更新数据
    setViewRange ({ commit, dispatch, state }, { start, end }) {
      // 第一次设置事件范围的时候,标记已初始化
      if (state.hadInited === false) {
        commit('SET_HAD_INITED', true)
      }
      if (
        state.viewRange.start.getTime() === start.getTime() &&
        state.viewRange.end.getTime() === end.getTime()
      ) {
        return
      }
      commit('SET_VIEW_RANGE', {
        start,
        end
      })
      dispatch('fetchData')
    },
    async fetchData ({ commit, state }) {
      commit('SET_LOADING', true)
      getAllowedScheduleEvent(state.viewRange.start, state.viewRange.end)
        .then(res => {
            
        window.eventIds=[]
        window._0eventIds=[]
          commit('SET_EVENTS', res)
        })
        .finally(() => {
          commit('SET_LOADING', false)
        })
    },
    addSchedule ({ commit, dispatch, state }) {
      commit('SET_LOADING', true)
      let arrs = state.selects.map(i => {
        return {
          end: i.EndTime,
          start: i.StartTime
        }
      })
      let sends = { isSend: state.isSend }
      // insertSchedule(arrs, sends)
      insertSchedule(arrs)
        .then(res => {
          console.log('addSchedule', res)
          // if (res.ErrorCode === 99) { // 与后端约定 当errorcode为99时，表示自主选课接口报错，前端展示系统错误提交框
          //   commit('SETERRORTEXT', res)
          // }
          commit('SETERRORTEXT', res)
          commit('SETSELFSCHEDULESENABLETHISTIME', true)
        })
        .finally(() => {
          commit('SET_LOADING', false)
          dispatch('fetchData')
          commit('SETCANSUBMIT', false)
          dispatch('getRestCourseCountOfNextWeek')

        })
    },
    prev ({ commit, state, dispatch }) {
      const prev = new Date(state.currentDate.getTime())
      prev.setDate(prev.getDate() - (state.currentView ? 7 : 1))
      commit('SET_CURRENT_DATE', prev)
      commit('SETCANSUBMIT', false)
      commit('UPDATE_ALLNOSELECTS')
      commit('MODIFYNEXTWEEKNUMBER', state.modifyNextWeekNumbers)
    },
    next ({ commit, state, dispatch }) {
      const next = new Date(state.currentDate.getTime())
      next.setDate(next.getDate() + (state.currentView ? 7 : 1))
      commit('SET_CURRENT_DATE', next)
      commit('SETCANSUBMIT', false)
      commit('UPDATE_ALLNOSELECTS')
      commit('MODIFYNEXTWEEKNUMBER', state.modifyNextWeekNumbers)

    },
    getRestCourseCountOfNextWeek({commit, state}) {
      getRestCourseCountOfNextWeek().then(res => {
        commit('MODIFYNEXTWEEKNUMBER', res)
      })
    }
  },
  getters: {
    events: state => state.events,
    initEvents: state => state.initEvents,
    currentDate: state => state.currentDate,
    currentView: state => state.currentView,
    loading: state => state.loading,
    viewRange: state => state.viewRange,
    hadInited: state => state.hadInited,
    errorText: state => state.errorText,
    eventIds:state=>state.eventIds,
    modifyNextWeekNumber:  state => state.modifyNextWeekNumber,
    setSelfSchedulesEnableThisTimes: state => state.setSelfSchedulesEnableThisTimes
  }
}
export default release
